// Auto generated file, do not manually modify!
// com.hotpads.listingdatamodeltypes.enums.ListingType

export enum ListingType {
  ASSISTED = 'ASSISTED',
  AUCTION = 'AUCTION',
  COMMERCIAL = 'COMMERCIAL',
  CORPORATE = 'CORPORATE',
  FORECLOSURE = 'FORECLOSURE',
  HOTEL = 'HOTEL',
  LAND = 'LAND',
  NEW_HOME = 'NEW_HOME',
  RENTAL = 'RENTAL',
  ROOM = 'ROOM',
  SALE = 'SALE',
  SUBLET = 'SUBLET',
  UNKNOWN = 'UNKNOWN',
  VACATION = 'VACATION',
}

export const ListingType_values = [
  ListingType.ASSISTED,
  ListingType.AUCTION,
  ListingType.COMMERCIAL,
  ListingType.CORPORATE,
  ListingType.FORECLOSURE,
  ListingType.HOTEL,
  ListingType.LAND,
  ListingType.NEW_HOME,
  ListingType.RENTAL,
  ListingType.ROOM,
  ListingType.SALE,
  ListingType.SUBLET,
  ListingType.UNKNOWN,
  ListingType.VACATION,
] as const;
